export default "__VITE_ASSET__ldqb6Ero__"